import { useContentGeneration } from './useContentGeneration';

/**
 * Custom hook for synopsis generation functionality
 * Wraps useContentGeneration with synopsis-specific naming
 */
export const useSynopsisGeneration = () => {
  const baseHook = useContentGeneration('synopsis', 'synopsis');

  // Map generic names to synopsis-specific names for backward compatibility
  return {
    // State - map to synopsis-specific names
    synopsisYoutubeUrl: baseHook.youtubeUrl,
    youtubeVideoInfo: baseHook.youtubeVideoInfo,
    extractingVideoInfo: baseHook.extractingVideoInfo,
    generatedSynopsis: baseHook.generatedContent,
    currentSynopsisProjectId: baseHook.currentProjectId,
    generatingSynopsis: baseHook.generatingContent,
    synopsisPrompt: baseHook.prompt,
    synopsisPromptVersion: baseHook.promptVersion,
    synopsisPromptTotalVersions: baseHook.promptTotalVersions,
    selectedPromptId: baseHook.selectedPromptId,
    selectedPromptVersionForUse: baseHook.selectedPromptVersionForUse,
    isEditingSynopsisPrompt: baseHook.isEditingPrompt,
    editedSynopsisPrompt: baseHook.editedPrompt,
    synopsisPromptLoading: baseHook.promptLoading,
    
    // Setters - map to synopsis-specific names
    setSynopsisYoutubeUrl: baseHook.setYoutubeUrl,
    setYoutubeVideoInfo: baseHook.setYoutubeVideoInfo,
    setExtractingVideoInfo: baseHook.setExtractingVideoInfo,
    setGeneratedSynopsis: baseHook.setGeneratedContent,
    setCurrentSynopsisProjectId: baseHook.setCurrentProjectId,
    setGeneratingSynopsis: baseHook.setGeneratingContent,
    setSynopsisPrompt: baseHook.setPrompt,
    setSynopsisPromptVersion: baseHook.setPromptVersion,
    setSynopsisPromptTotalVersions: baseHook.setPromptTotalVersions,
    setSelectedPromptId: baseHook.setSelectedPromptId,
    setSelectedPromptVersionForUse: baseHook.setSelectedPromptVersionForUse,
    setIsEditingSynopsisPrompt: baseHook.setIsEditingPrompt,
    setEditedSynopsisPrompt: baseHook.setEditedPrompt,
    setSynopsisPromptLoading: baseHook.setPromptLoading,
    
    // Functions - map to synopsis-specific names
    extractYoutubeVideoInfo: baseHook.extractYoutubeVideoInfo,
    generateSynopsisFromDescription: baseHook.generateContentFromDescription,
    fetchSynopsisPrompt: baseHook.fetchPrompt,
    fetchSynopsisPromptVersion: baseHook.fetchPromptVersion,
    handleSynopsisPromptVersionChange: baseHook.handlePromptVersionChange,
    clearSynopsisState: baseHook.clearState,
    saveSynopsisPrompt: baseHook.savePrompt,
  };
};

